import { client } from './client.js';
import type { DeviceCodeResponse } from './schemas.js';

export async function requestDeviceCode(): Promise<DeviceCodeResponse> {
  return client.requestDeviceCode();
}
